import { ENDPOINTS } from 'config/endpoints';
import { useMutation } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { IGenerateStrategyTargetAudienceChallenges } from './useGetStrategyTargetAudienceChallenges';

export interface IGenerateStrategyProductBenefits extends IGenerateStrategyTargetAudienceChallenges {
  targetAudienceChallenges: string[] | null;
}

export default function useGenerateStrategyProductBenefits() {
  const generateStrategyTargetAudience = (
    strategyProductBenefits: IGenerateStrategyProductBenefits,
  ) => {
    const request: Request = {
      url: `${ENDPOINTS.assistant.strategy.productBenefits}`,
      config: {
        method: 'post',
        data: { data: strategyProductBenefits },
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<string[] | null>,
    CronoError,
    IGenerateStrategyProductBenefits
  >(generateStrategyTargetAudience, { meta: { silentError: true } });

  return { data, mutate, ...rest };
}
